import React from 'react';
import { T } from './traks';

const achievements_raw = [
	["game_won", <T>Won a game</T>, <T>You won a game with at least 5 players! Plain and simple!</T>],
	["game_lost", <T>Lost a game</T>, <T>You lost a game with at least 25 players. Not as easy as it sounds.</T>],
	["pump_n_dump", <T>Pump'n'dump</T>, <T>Earned more than 10 times on a stock of less value than 1 DKK/USD at the time of purchase (UNIMPLEMENTED)</T>],
	["won_with_initial_portfolio", <T>Got it right the first time</T>, <T>Won a game without ever selling any stock (the game must have at least 5 players)</T>],
	["oops_50pct", "Facepalm", <T>Sold stock just before it went up by 50% (UNIMPLEMENTED)</T>],
	["crypto_only", <T>Cryptographer</T>, <T>Won a game with only Crypto-currencies (UNIMPLEMENTED)</T>],
	["trouble_then_double", <T>When in trouble then double</T>, <T>A stock has fallen more than 20% and you used the chance to double your amount of it (UNIMPLEMENTED)</T>],
	["lost_50pct", <T>Lost half or more</T>, <T>You lost more than 50% value of an asset (UNIMPLEMENTED)</T>],
];

var achievement_map = {};
for (const [id, title, desc] of achievements_raw) {
	achievement_map[id] = {title, desc};
}

const achievement_ids = achievements_raw.map(x => x[0]);

export {
	achievements_raw,
	achievement_ids,
	achievement_map
}



// WEBPACK FOOTER //
// ./src/AchievementInfo.js